import {BusinessSourceOfFunds, BusinessSourceOfFundsMapping} from "../../resources/application"
import React from "react"
import {Editable, EditableDropDownField} from "../HorizontalField/EditableHorizontalField"

export interface EditableBusinessSourceOfFundsProps {
	sourceOfFunds?: BusinessSourceOfFunds
	setSourceOfFunds: (value: BusinessSourceOfFunds) => void
	isEditing: boolean
	isDisabled: boolean
	isAllowed: boolean
	onStartEdit: () => void
	onCancel: () => void
	update: (value: BusinessSourceOfFunds) => void
	className?: string
}

export function EditableBusinessSourceOfFundsField(props: EditableBusinessSourceOfFundsProps) {
	if (props.sourceOfFunds) {
		return (
			<Editable
				label="Source of Funds"
				isEditing={props.isEditing}
				isDisabled={props.isDisabled}
				isAllowed={props.isAllowed}
				onStartEdit={props.onStartEdit}
				onCancel={props.onCancel}
				setValue={props.setSourceOfFunds}
				value={props.sourceOfFunds}
				initial={props.sourceOfFunds}
				update={props.update}
				className={props.className}
				possibleValues={BusinessSourceOfFundsMapping}
			>
				{EditableDropDownField}
			</Editable>
		)
	}

	return null
}
